/**
 * Inc5 · Informe MAAM de resultados de una ejecución
 * (`/api/resultados-autoevaluacion`).
 *
 * Capa de servicios: una función por operación del API. No lanza nunca —cada
 * función devuelve un valor neutro ante el fallo—, así que el llamador debe
 * comprobar el resultado, no envolver en try/catch.
 */

import type { ResultadosAutoevaluacion } from '@/interfaces/ResultadosAutoevaluacion'
import { http, primerError } from '@/services/http'

/** Forma con la que el API de resultados autoevaluacion devuelve este dato. */
export interface ResultadoResultados {
  ok: boolean
  status: number
  data?: ResultadosAutoevaluacion
  error?: string
}

/**
 * Inc5 · Resultados de autoevaluación (informe MAAM) de una ejecución.
 * GET /api/ejecuciones/{id}/resultados  (permiso calificacion.ver)
 */
export async function getResultadosAutoevaluacionService(idEjecucion: number): Promise<ResultadoResultados> {
  const result = await http.get<ResultadosAutoevaluacion>(`/api/ejecuciones/${idEjecucion}/resultados`)
  if (!result.ok) {
    return { ok: false, status: result.status, error: primerError(result, 'No se pudieron cargar los resultados') }
  }
  return { ok: true, status: result.status, data: result.data }
}
